import { TextField, TextFieldProps } from "@justhome/react-ui";
import {
  Control,
  FieldPath,
  FieldValues,
  Path,
  PathValue,
  UseControllerProps,
  useController,
} from "react-hook-form";

const ControlledTextField = <T extends FieldValues>({
  control,
  suffix,
  disabled,
  name,
  rules,
  defaultValue,
  alwaysShowError = false,
  ...props
}: TextFieldProps & {
  name: FieldPath<T>;
  control: Control<T>;
  rules?: UseControllerProps<T>["rules"];
  defaultValue?: PathValue<T, Path<T>>;
  alwaysShowError?: boolean;
}) => {
  const {
    field: { ref, ...field },
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const errorMessage = error?.message;
  const isInvalid = (isTouched || isSubmitted) && invalid;

  return (
    <TextField
      {...props}
      {...field}
      suffix={suffix}
      disabled={disabled}
      ref={ref}
      data-testid={field.name}
      errorMessage={isInvalid || alwaysShowError ? errorMessage : undefined}
    />
  );
};

export default ControlledTextField;
